import { mediaMixin, spaceMixin, spacingMixin } from '@zillow/constellation';

import { css } from 'styled-components';

const getAlignment = ({ align }) => {
  if (align) {
    return css`
      display: flex;
      flex-direction: column;
      align-items: ${align};
    `;
  }
  return null;
};

const getHorizontalAlignment = ({ alignHorizontal }) => {
  if (alignHorizontal) {
    return css`
      display: flex;
      flex-direction: column;
      align-items: ${alignHorizontal};
    `;
  }
  return null;
};

const getVerticalAlignment = ({ alignVertical }) => {
  if (alignVertical) {
    return css`
      display: flex;
      flex-direction: column;
      justify-content: ${alignVertical};
    `;
  }
  return null;
};

export default (props) =>
  props.theme &&
  props.theme.ns &&
  css`
    && {
      ${getHorizontalAlignment}
      ${getVerticalAlignment}
            ${getAlignment}
            ${mediaMixin(
        'xs',
        css`
          padding-left: 0 !important;
          padding-right: 0 !important;
        `,
      )}

            ${mediaMixin(
        'lg',
        css`
          padding-left: ${spaceMixin('xs')} !important;
          padding-right: ${spaceMixin('xs')} !important;
        `,
      )}

            ${mediaMixin(
        'xl',
        css`
          padding-left: ${spaceMixin(1.5)} !important;
          padding-right: ${spaceMixin(1.5)} !important;
        `,
      )}

            ${props.noPadding &&
      css`
        & {
          padding: 0 !important;
        }
      `}

            & {
        ${spacingMixin};
      }
    }
  `;
